import { render, staticRenderFns } from "./BuscarContatoMarca.vue?vue&type=template&id=8661a504&scoped=true&"
import script from "./BuscarContatoMarca.vue?vue&type=script&lang=js&"
export * from "./BuscarContatoMarca.vue?vue&type=script&lang=js&"
import style0 from "./BuscarContatoMarca.vue?vue&type=style&index=0&id=8661a504&scoped=true&lang=css&"
import style1 from "./BuscarContatoMarca.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8661a504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VDialog,VFlex,VLayout,VListTileAvatar,VListTileContent,VListTileSubTitle,VListTileTitle,VSpacer})
